import { MDBBtn, MDBDropdown, MDBDropdownToggle, MDBDropdownItem, MDBDropdownMenu, MDBRadio } from 'mdb-vue-ui-kit';
import {useUserInfoStore} from "@/stores/Setup/userInfo";
import {storeToRefs} from "pinia";
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default {
    name: 'DownloadData',
    emits: ['print','print-matrix-only','download-csv'],
    components: {MDBBtn,MDBDropdown, MDBDropdownToggle, MDBDropdownItem, MDBDropdownMenu, MDBRadio },
    setup(props) {

        const route = useRoute();

        // Resolve source in a consistent way
        const resolvedAnalysisType = computed(() =>
            props.analysisType
            || (route.params?.type && ['wheel','crosswalk'].includes(route.params.type) ? route.params.type : null)
            || (route.query?.type && ['wheel','crosswalk'].includes(route.query.type) ? route.query.type : null)
            || 'wheel'
        );

        const userInfoStore = useUserInfoStore()
        const { consentShareData } =  storeToRefs(userInfoStore)
        const { consentIncludeName } =  storeToRefs(userInfoStore)

        return {consentShareData, consentIncludeName, resolvedAnalysisType}
    },
    methods: {
        onPrintAll() { this.$emit('print') },
        onPrintMatrixOnly() { this.$emit('print-matrix-only') },
        onDownloadCsv() { this.$emit('download-csv') },
    }
}